class Accordion {
    constructor(c = {}) {
        this.trigger = c.trigger
        this.content = this.trigger.nextElementSibling;

        this.icons = this.trigger.querySelectorAll('.wu-icon')
        this.start()
    }
    start() {
        this.listener()
        this.hashUpdateListener()
        window.onhashchange = this.hashUpdateListener
    }
    hashUpdateListener() {
        const hash = location.hash
        if (hash && hash.match(/#faq-accordion-el-.-./)) {
            let tabNumber = hash.split('-')[4];
            const tabEl = document.getElementById(`#tabpanel-id-${tabNumber}`)
            if (tabEl) {
                tabEl.click()
                const accordionEl = document.getElementById(hash.replace('#', ''))
                accordionEl && accordionEl.click()
            }
        } else if (hash && hash === `#${this.trigger.parentElement.id}`) {
            this.trigger.click();
        }
    }
    listener() {
        this.trigger.addEventListener('click', e => {
            this.handler()
        })
    }
    handler() {
        this.trigger.classList.toggle('active')
        this.content.classList.toggle('active')
        for (let i = 0; i < this.icons.length; i++) {
            this.icons[i].classList.toggle('d-none')
        }
    }
}
let accordionTriggers = document.querySelectorAll('[data-accordion-trigger]')

if (/complete|interactive|loaded/.test(document.readyState)) {
    statAccordion();
} else {
    window.addEventListener("DOMContentLoaded", statAccordion);
}

function statAccordion() {
    accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');
    if (accordionTriggers.length > 0) {
        for (let i = 0; i < accordionTriggers.length; i++) {
            new Accordion({
                trigger: accordionTriggers[i]
            })
        }
    }
}

window.Accordion = Accordion
